
import React from 'react'
import {connect} from "react-redux";
import {servidor, servicioRestfulCompleto, servicioRestfulMinimo, servicioDocumental} from "../Configuracion";
import {
    CELLTIPO_CADENA,
    CELLTIPO_COLOR,
    CELLTIPO_ENTERO,
    CELLTIPO_FECHA,
    CELLTIPO_FOREIGN,
    CELLTIPO_ICONOACCION,
    CELLTIPO_ICONOACCION_DESCARGAR,
    CELLTIPO_ICONOACCION_ELIMINAR, CELLTIPO_IMAGENLISTA,
    COLUMNVISIBLE_SIEMPRE,
} from "../../framework2/ej2/UI/TiposCeldas";
import "../resources/css/encabezado.css";
import "../resources/css/selectorperiodo.css";
import FormularioBotonera, {
    BOTONERA_ACCION_NUEVO, BOTONERA_ACCION_REFRESCAR,
    BOTONERA_REFRESCAR
} from "../../framework2/ej2/UI/FormularioBotonera";
import ClienteRestful from "../../framework2/ej2/network/ClienteRestful";
import {Intent, Spinner} from "@blueprintjs/core";
import GridRDG from "../../framework2/adazzle/GridRDG";
import Titulo from "../../framework2/ej2/UI/Titulo";
import Tratamiento from "./Tratamiento";
import PropTypes from "prop-types";
import {
    COMPONENTE_TIPO_DATE,
    COMPONENTE_TIPO_FOREIGN,
    COMPONENTE_TIPO_FOREIGN_SERVIDOR,
    COMPONENTE_TIPO_INPUT,
    COMPONENTE_TIPO_SELECT,
    COMPONENTE_TIPO_SELECT_MULTI,
    loadDatos,
    loadDatosServicio,
    loadDatosURL,
    renderFormulario,
    renderGrid,
    showSelectBusqueda
} from "../utils/FormularioUtils";
import {dientes, tiposPagos, zonas} from "../utils/Definiciones";
import Paciente from "./Paciente";
import SelectorPeriodo from "../../framework2/ej2/UI/SelectorPeriodo";
import Pago from "./Pago";
import FileUploaderSimple from "../../framework2/ej2/UI/FileUploaderSimple";
import Dialogo from "../../framework2/blueprint/Dialogo";
import {descargarDocumento} from "../utils/DocumentosUtils";
import SelectorDocumentos from "./SelectorDocumentos";

class Documentos extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            showGrid: true,
            cargandoDatos: false,
            elementoSeleccionado: null,
            datos: [],
            elementoShow: false,
            marcaTiempo: new Date(),
        }

        this.columnas= [
            {campo:"tipo", titulo: "Tipo", tipo: CELLTIPO_IMAGENLISTA, ancho:50,
                imagenes: [
                    {valor:'png', imagen:'png2.png'},
                    {valor:'jpg', imagen:'jpg2.png'},
                    {valor:'jpeg', imagen:'jpg2.png'},
                    {valor:'pdf', imagen:'pdf2.png'},
                    {valor:'ods', imagen:'xls2.png'},
                    {valor:'txt', imagen:'txt2.png'}]},
            {campo:"nombre", titulo: "Nombre", tipo: CELLTIPO_CADENA, ancho:300},
            {campo:"fecha", titulo: "Fecha", tipo: CELLTIPO_CADENA, ancho:140},
            {campo:"tamagno", titulo: "Tamaño", tipo: CELLTIPO_CADENA, ancho:100},
            {campo:"descargar", tipo: CELLTIPO_ICONOACCION_DESCARGAR, ancho: 50, onAccion: this.descargarDocumento},
            //{campo:"eliminar", tipo: CELLTIPO_ICONOACCION_ELIMINAR, ancho: 50, onAccion: this.eliminarDocumentoPrevio},
        ];
    }

    componentDidMount() {
        this.loadDatos();
    }


    loadDatos= () =>{
        const {paciente, nombreClase} = this.props;
        let url= servidor + servicioDocumental + "list/" + nombreClase + "/" + paciente.codigo;
        loadDatosURL(this, url, {});
    }

    // ------------------------------------------------------------------------------------------------------------
    // DOCUMENTOS
    // ------------------------------------------------------------------------------------------------------------
    descargarDocumento= (documento) => {
        const {paciente, nombreClase} = this.props;
        descargarDocumento(nombreClase, paciente.codigo, documento);
    }
    documentoUploaded= (file) => {
        console.log(">>>>>>> Documento uploaded <<<<<<<" );
        //this.setState({marcaTiempoGrid: Date.now()});
        this.loadDatos();
    }
    documentoError= () => {
        alert("Error al enviar el archivo");
    }


    /* ----------------- ELIMINAR  ------------ */

    eliminarElemento= () => {
        const {elementoSeleccionado} = this.state;
        const {nombreClase, paciente} = this.props;

        console.log("ELIMINAR DOCUMENTO");
        console.log(elementoSeleccionado);
        console.log("props: ", this.props);

        const {usuario} = this.props.auth;

        let url= servidor + servicioDocumental +
            nombreClase + "/" + paciente.codigo + "/" + elementoSeleccionado.nombre + "/" + usuario.codigo;

        console.log("url: ", url);
        const clienteRestful = new ClienteRestful().setUrl(url);
        clienteRestful.doDelete(response => {
            this.setState({dialogoTexto: null}, () => this.loadDatos());
        });

    }




    //------------------------------------------------------------------------------------------------------------------
    // ACCIONES
    //------------------------------------------------------------------------------------------------------------------

    onAccion= (accion, elemento) => {
        switch (accion){
            case BOTONERA_ACCION_REFRESCAR:
                this.loadDatos();
                break;
        }
    }



    render() {
        const {showGrid, datos, elementoSeleccionado,
               dialogoTitulo, dialogoTexto, dialogoTipo, dialogoOnQuestion, dialogoOnClose} = this.state;
        const {paciente, nombreClase} = this.props;

        let servicioUploadUrl= servidor + servicioDocumental + "upload/" +
            nombreClase + "/" + paciente.codigo + "/";

        let propiedadesGrid= {mostrarBotonera: false, height:300};

        return (
            <div style={{margin: 8, padding: 4}}>
                <Titulo titulo="Gestión de Documentos" soloTitulo={true}/>

                <Dialogo titulo={dialogoTitulo} mensaje={dialogoTexto} tipo={dialogoTipo}
                         onQuestion={dialogoOnQuestion}
                         onClose={dialogoOnClose}
                />

                {renderGrid(this, "Documentos", datos, this.onAccion, propiedadesGrid)}
                <FormularioBotonera
                    numElementos={datos ? datos.length : 0}
                    showAcciones={[BOTONERA_REFRESCAR]}
                    onAccion={this.onAccion}
                    elementoSeleccionado={elementoSeleccionado}
                />

                {/*}
                <FileUploaderSimple   url={servicioUploadUrl}
                                      onFileUploaded={this.documentoUploaded}
                                      onFileError={this.documentoError}
                                      acceptTypes={"image/jpeg, image/png, application/pdf"}
                                      mostrarEnviar={true}
                /> */}
                <SelectorDocumentos
                    uploadUrl={servicioUploadUrl}
                    onFileUploaded={this.documentoUploaded}
                    onFileError={this.documentoError}
                    acceptTypes={"image/jpeg,image/png,application/pdf"}
                />
            </div>
        )
    }

}

Documentos.propTypes = {
    nombreClase: PropTypes.string,
    paciente: PropTypes.object,
    llamador: PropTypes.object,
}

const mapStateToProps = function(state) {
    return {
        auth: state.auth,
        datosmaestros: state.datosmaestros,
        estado: state.estado,
    }
}
export default connect(mapStateToProps)(Documentos);



